module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showFlag == 1) ? _c('span', [(_vm.caseTM) ? _c('span', {
    staticClass: "addStyle pointer",
    on: {
      "click": function($event) {
        _vm.openTrain(_vm.caseID)
      }
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#2196f3"
    }
  }, [_vm._v("恢复训练")])]) : _c('span', {
    staticClass: "addStyle pointer",
    on: {
      "click": function($event) {
        _vm.openTrain(_vm.caseID)
      }
    }
  }, [_vm._v("现场训练")])]) : _c('mu-raised-button', {
    staticStyle: {
      "border-radius": "40px"
    },
    attrs: {
      "label": "现场训练",
      "primary": ""
    },
    on: {
      "click": function($event) {
        _vm.openTrain(_vm.caseID)
      }
    }
  }), _vm._v(" "), (_vm.showTrain) ? _c('trainModal2', {
    ref: "supervisedTrainDialog",
    attrs: {
      "caseId": _vm.caseID
    },
    on: {
      "close": _vm.closeTrain,
      "submitData": _vm.submitCase
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showTimeTrain) ? _c('timeModalSelect', {
    ref: "timesupervisedTrainDialog",
    attrs: {
      "caseId": _vm.caseID
    },
    on: {
      "close": _vm.closeTrain
    }
  }) : _vm._e(), _vm._v(" "), (_vm.saveGame) ? _c('trainCronSave', {
    attrs: {
      "rest": _vm.rest,
      "gameData": _vm.gameData,
      "gameFlag": 1,
      "caseId": _vm.caseID
    },
    on: {
      "update:rest": function($event) {
        _vm.rest = $event
      },
      "updateScore": _vm.getGameScore,
      "close": function($event) {
        _vm.saveGame = false
      },
      "restart": _vm.over
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showOver) ? _c('gameOver', {
    attrs: {
      "score": _vm.gameScore,
      "gameFlag": _vm.flag
    },
    on: {
      "restart": _vm.restartTrain,
      "close": _vm.closeGame
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showTimeError) ? _c('zeroLeft', {
    on: {
      "close": function($event) {
        _vm.showTimeError = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1f99fbe6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/train/trainScene.vue
// module id = 962
// module chunks = 2